module.exports = __webpack_public_path__ + "static/filter-37227ee2709904ae64499fbd191d2368.png";